import API from "../../services/api";

// ===============================
// Get Pending Providers
// ===============================

export const getPendingProviders = async () => {
    const response = await API.get(
        "/admin/providers/pending"
    );

    return response.data;
};

// ===============================
// Get Provider Details
// ===============================

export const getProviderDetails = async (id) => {
    const response = await API.get(
        `/admin/providers/${id}`
    );

    return response.data;
};

// ===============================
// Approve Provider
// ===============================

export const approveProvider = async (id) => {
    const response = await API.put(
        `/admin/providers/${id}/approve`
    );

    return response.data;
};

// ===============================
// Reject Provider
// ===============================

export const rejectProvider = async (
    id,
    reason
) => {
    const response = await API.put(
        `/admin/providers/${id}/reject`,
        { reason }
    );

    return response.data;
};